import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type { CreateSoilAnalysisPayload, SoilAnalysisDTO } from './types';

export const usePostSoilAnalysis = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async (data: CreateSoilAnalysisPayload) => {
			try {
				return (await api.post<SoilAnalysisDTO>('/soil-analysis/store', data, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar análise de solo');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['soilAnalysis'] });
			queryClient.invalidateQueries({ queryKey: ['soilAnalysis', variables.area] });
		},
		onError: (error) =>
			console.error(
				'Erro ao criar análise de solo:',
				getApiErrorMessage(error, 'Erro ao criar análise de solo')
			),
	});
};
